import infoo from "../plugins/infoo";
import Vue from "vue";
export const _sync = {
  mutable: false,
  multiple: false,
  source: ["default", "local", "create", "download"]
};

const config = {
  namespaced: false,
  state: {
    configs: {},
    configDefault: {
      _time: null,
      _cambio: true,
      _source: "configDefault",
      id: "__",
      enum: "", // easy number, mejor dicho, el telefono
      licenId: "__", // licencia activa
      etq: {
        tdo: 0, // total donaciones
        tsu: 0 // total suscripciones
      }, // etiquetas
      rls: {}, // roles
      per: {
        nombre: "",
        fCumple: "",
        sexo: "",
        jerq: ""
      },
      ubi: {
        pais: "",
        depto: "",
        ciudad: ""
      },
      mdd: {
        cod: "es",
        col: "b", // color del subrayado
        lng: "es",
        ver: "",
        tam: 2,
        por: 26
      },
      orm: {
        san: true,
        rec: [
          { dia: 1, act: false, hora: "05:30" },
          { dia: 2, act: false, hora: "05:30" },
          { dia: 3, act: false, hora: "05:30" },
          { dia: 4, act: false, hora: "05:30" },
          { dia: 5, act: false, hora: "05:30" },
          { dia: 6, act: false, hora: "06:30" },
          { dia: 0, act: false, hora: "06:30" }
        ]
      },
      orn: {
        com: false,
        rec: [
          { dia: 1, act: false, hora: "21:00" },
          { dia: 2, act: false, hora: "21:00" },
          { dia: 3, act: false, hora: "21:00" },
          { dia: 4, act: false, hora: "21:00" },
          { dia: 5, act: false, hora: "21:00" },
          { dia: 6, act: false, hora: "21:00" },
          { dia: 0, act: false, hora: "21:00" }
        ]
      },
      cua: {
        vista: "dia",
        color: 5,
        light: 4
      }
    },
    id: "__"
  },
  getters: {
    config(state) {
      return state.configs[state.id]
        ? state.configs[state.id]
        : state.configDefault;
    },
    ready(state) {
      return state.configs[state.id]
        ? state.configs[state.id]._time
        : state.configDefault._time;
    }
  },
  mutations: {
    setConfig(state, config) {
      Vue.set(state.configs, config.id, config);
      this.$local.set("user/config/" + config.id, config);
      state.id = config.id;
    },
    updateConfig(state, payload) {
      // data = {mdd: {tam: 2}}
      // let payload = {
      //   id: this.userConfig.id,
      //   data: { mdd: { tam: v } },
      //   prop1: "mdd",
      //   prop2: "tam",
      //   level: 2,
      //   value: v
      // };
      payload.data._time = infoo.timeStamp();

      if (payload.level === 1) {
        state.configs[payload.id][payload.prop1] = payload.value;
      } else {
        state.configs[payload.id][payload.prop1][payload.prop2] = payload.value;
      }

      this.$local.set("user/config/" + payload.id, state.configs[payload.id]);
    },
    clearConfig(state) {
      let obj = JSON.parse(JSON.stringify(state.defaultConfig));
      Vue.set(state, "config", obj);
    }
  },
  actions: {
    async createInvitedConfig({ state, commit, getters, rootGetters }) {
      // TODO: validar que esto no se hizo antes

      // Datos personales - - - - - -
      let def = JSON.parse(JSON.stringify(state.configDefault));
      def.per.nombre = getters.auth.name;

      // location - - - - - - - - - - - - - - - - - - - - - - - -
      let location = this.$local.get("app/helpers/clientLocation");
      if (!location) {
        location = rootGetters["app/helpers/clientLocation"];
      }

      if (location.countryCode !== undefined) {
        def.ubi.pais = location.countryCode.toLowerCase();
        def.ubi.depto = location.region;
        def.ubi.ciudad = location.city;
      }

      // browser = { lng: "", country: "" };
      let browser = infoo.browser;

      // version del libro - - - - - - - - -
      let params = rootGetters["app/params"];
      let appLangs = params.langs;
      let bookVersions = params.bookVersions;

      let mddLng = false;
      let mddVer = false;
      let mddCod = false;

      appLangs.forEach(lng => {
        if (lng.cod === browser.lng) {
          mddLng = lng.cod;
          mddCod = lng.cod;
        }
      });

      bookVersions.forEach(book => {
        if (book.lng === browser.lng && book.ver === def.ubi.pais) {
          mddVer = book.ver;
          mddCod = book.lng + book.ver;
        }
      });

      def.mdd.cod = mddCod ? mddCod : "es";
      def.mdd.lng = mddLng ? mddLng : "es";
      def.mdd.ver = mddVer ? mddVer : "";

      // def._time = this.$fb.firebase_.firestore.Timestamp.now().seconds;
      def._time = infoo.timeStamp();
      def._source = "createInvitedConfig";
      commit("setConfig", def);
    },
    getConfig({ commit, getters, dispatch }) {
      let id = getters.auth.uid;
      let config = this.$local.get("user/config/" + id);

      if (config) {
        commit("setConfig", config);
      } else {
        dispatch("createInvitedConfig");
      }

      return;
    },
    valideAndSave({ commit }, config) {
      config.mdd.cod = config.mdd.lng + config.mdd.ver;
      commit("setConfig", config);
    },
    getConfigFromWeb() {
      // si el usuario es invitado, omite la consulta
      // este método se invoca cuando el usuario ingresa a la ventana de configuracion
      // se llama desde router y al iniciar la app, se omite si la ultima vez fue recien
    },
    setConfigOnWeb({ commit, dispatch, getters }, data) {
      // toda la configuracion del usuario || null
      let uid = getters.auth.uid;
      // Para crear requiere estar autenticado
      if (!uid) return "";

      if (!data) data = getters["config"];

      // TODO: se requiere que data tenga todos los campos o los complemente
      // data._time = this.$fb.firebase_.firestore.Timestamp.now().seconds;
      data._time = infoo.timeStamp();
      let users = this.$collection.users;
      users
        .doc(uid)
        .update(data)
        .then(() => {
          commit("setConfig", data);
        })
        .catch(e => {
          dispatch(
            "app/saveErrorReport",
            { e: e, line: 149, src: "user.js" },
            { root: true }
          );
        });
    }
  }
};

export default config;
